import { AuthContext, AuthUser } from '@contexts';
import { PAGES, RECEIVED, UserRole } from '@helpers';
import { signInSuccess } from '@state/authSlice';
import {
  changeRequestStatus,
  changeUserListFilter,
  clearSelectedUsersId
} from '@state/users/userSlice';
import { RequestStatus } from '@utils/types';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { changeOneAccessTypeFilter } from '@state/files/filesSlice';

const AutoLogin = () => {
  const { autoSignIn, isLoading } = useContext(AuthContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const q = new URLSearchParams(window.location.search);
  const token = q.get('token')!;
  const email = q.get('email')!;
  autoSignIn(email, token).then((user: AuthUser) => {
    if (user?.error) {
      Promise.reject(user?.error);
      return;
    }
    dispatch(signInSuccess());
    const Role: UserRole = user?.getSignInUserSession()?.getIdToken().payload[
      'custom:account_type'
    ];

    let userUrl = PAGES.Home;
    dispatch(changeOneAccessTypeFilter([RECEIVED]));

    switch (Role) {
      case UserRole.ADMIN:
        dispatch(changeUserListFilter(UserRole.STAFF));
        userUrl = PAGES.Admin;
        break;
      case UserRole.STAFF:
        dispatch(changeUserListFilter(UserRole.CUSTOMER));
        userUrl = PAGES.Staff;
        break;
      default:
        break;
    }
    dispatch(changeRequestStatus(RequestStatus.IDLE));
    dispatch(clearSelectedUsersId());
    history.push(userUrl);
  });
  if (isLoading) {
    return <div>Loading...</div>;
  }
  return <Redirect to={PAGES.Login} />;
};

export default AutoLogin;
